import React from 'react';
const painPoints: string[] = ['Despiertas cansada, como si no hubieras dormido nada.', 'Sientes que tu cuerpo grita lo que tu mente calla.', 'Vives con dolores que los médicos llaman "solo estrés".', 'Buscas una solución natural que no sea otra pastilla.'];
export function Vsl() {
  return <section className="px-5 py-14 sm:px-8" style={{
    background: 'linear-gradient(160deg, #0c0c0c 0%, #2d1b4e 100%)'
  }} data-id="element-127" data-mp="2aydhokwphvko">
      <div className="mx-auto max-w-3xl text-center" data-id="element-128" data-mp="2fwor4uj3a42d">
        <p className="flex items-center justify-center gap-2 text-[11px] font-black uppercase tracking-[0.12em] text-white/85 sm:text-[12px]" data-id="element-129" data-mp="2kwt78jg34ws2">
          <span aria-hidden="true" className="live-dot h-2.5 w-2.5 rounded-full bg-red-500" data-id="element-130" data-mp="2ozhe4ll8ntme" />
          Mira esto antes de que el contador llegue a cero
        </p>

        <div className="mt-4 overflow-hidden rounded-xl border-2 border-gold" style={{
        boxShadow: '0 0 34px rgba(26, 74, 46, 0.85), 0 0 0 1px rgba(201,168,76,0.25)'
      }} data-id="element-131" data-mp="uknah5aair6t">
          <video className="block aspect-video w-full bg-black" src="https://res.cloudinary.com/lkfj1jku/video/upload/v1787190134/VSL_manual_Autosanacion.mp4" controls playsInline preload="metadata" data-id="element-132" data-mp="zlb7q8p4449h">
            Tu navegador no soporta la reproducción de video.
          </video>
        </div>

        {/* Pain points — the avatar's bridge */}
        <div className="mt-11" data-id="element-133" data-mp="1xd4v8he35t8w">
          <h2 className="font-display text-[18px] font-normal italic tracking-wide text-gold/90 sm:text-[22px]" data-id="element-134" data-mp="1xdwqfr3rtoyn">
            ¿Te sientes identificada con esto?
          </h2>
          <ul className="mt-5 grid gap-3 text-left sm:grid-cols-2" data-id="element-135" data-mp="2q22dikiarq1n">
            {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-lg border border-white/10 bg-white/[0.04] px-4 py-3" data-id="element-136" data-mp="2l0lbumrznzk0">
                <span aria-hidden="true" className="mt-0.5 text-[13px] text-gold" data-id="element-137" data-mp="2g2blcph7ln4q">
                  ✦
                </span>
                <span className="text-[14px] leading-snug text-white/85 sm:text-[15px]" data-id="element-138" data-mp="14nehwaka2vdu">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}